import c from "./lib/createApi";

/**
 * account는 로그인 전 유저 관련
 */
export default {
};
